// extracted by mini-css-extract-plugin
module.exports = {"company-donation":"company-donation__PNpKd","company-donation__highlighted-field":"company-donation__highlighted-field__SGA_g"};